<template>
  <generic-modal :modal-key="'welcome_returning_unsub'" :has-extra-modal-class="'popup_box op_down modal_cont'"
                 @close="$emit('close')">
    <template slot="content">
      <h1>{{ getTranslations.home_modals_welcome_back_returning_back_welcome_back }} {{ userDetails.username }}!</h1>
      <img class="modal_icon_main" src="static/images/re_subscribe.png" alt="">
      <p>{{ getTranslations.home_modals_welcome_back_returning_back_you_start }}</p>
    </template>
  </generic-modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import GenericModal from '../sharedcomponents/GenericModal';

export default {
  // modal_resubscribe_welcome_back.html
  name: 'welcome-returning-unsub',
  components: { GenericModal },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/WelcomeReturningUnsub.vue